import React, { useState, useEffect } from 'react';

const FeaturesBar = () => {
  const [position, setPosition] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPosition((prevPosition) => {
        // Reset position when content goes off screen
        if (prevPosition <= -100) {
          return 100;
        }
        return prevPosition - 0.15; // Even slower for better readability
      });
    }, 30); // Smooth animation

    return () => clearInterval(interval);
  }, []);

  const features = [
    {
      icon: 'verified',
      text: 'Premium Quality Materials'
    },
    {
      icon: 'design_services',
      text: 'Expert Interior Design'
    },
    {
      icon: 'shield',
      text: '5 Year Warranty'
    },
    {
      icon: 'eco',
      text: 'Eco-Friendly Solutions'
    },
    {
      icon: 'favorite',
      text: 'Trusted by 1000+ Clients'
    },
    {
      icon: 'star',
      text: 'Award Winning Designs'
    },
    {
      icon: 'speed',
      text: 'On-Time Delivery'
    },
    {
      icon: 'support_agent',
      text: '24/7 Customer Support'
    },
    {
      icon: 'home_work',
      text: 'Custom Furniture Design'
    },
    {
      icon: 'palette',
      text: 'Color Consultation'
    },
    {
      icon: 'architecture',
      text: 'Space Planning'
    },
    {
      icon: 'light_mode',
      text: 'Lighting Design'
    }
  ];

  return (
    <section className="relative overflow-hidden py-6 sm:py-8 bg-gradient-to-r from-gray-900 via-black to-gray-900 border-y border-amber-900/30 shadow-xl">
      {/* Gradient overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/30 to-transparent pointer-events-none"></div>
      
      {/* Marquee container */}
      <div className="relative">
        <div 
          className="flex items-center"
          style={{
            transform: `translateX(${position}%)`,
            transition: 'transform 0.03s linear'
          }}
        >
          {/* First set of features */}
          <div className="flex items-center gap-6 sm:gap-8 md:gap-10 px-6">
            {features.map((feature, index) => (
              <div key={index} className="flex items-center gap-3 sm:gap-4 shrink-0 group">
                {/* Icon container with hover effect */}
                <div className="w-12 h-12 sm:w-14 sm:h-16 md:w-16 md:h-18 flex items-center justify-center rounded-full bg-gradient-to-br from-amber-600 to-amber-700 shadow-lg group-hover:shadow-amber-500/50 transition-all duration-300 group-hover:scale-110">
                  <span className="material-symbols-outlined text-white text-xl sm:text-2xl md:text-3xl">
                    {feature.icon}
                  </span>
                </div>
                {/* Feature text */}
                <p className="text-sm sm:text-base md:text-lg font-bold text-amber-400 whitespace-nowrap group-hover:text-amber-300 transition-colors duration-300">
                  {feature.text}
                </p>
              </div>
            ))}
          </div>
          
          {/* Duplicate set for seamless loop */}
          <div className="flex items-center gap-6 sm:gap-8 md:gap-10 px-6">
            {features.map((feature, index) => (
              <div key={`duplicate-${index}`} className="flex items-center gap-3 sm:gap-4 shrink-0 group">
                {/* Icon container with hover effect */}
                <div className="w-12 h-12 sm:w-14 sm:h-16 md:w-16 md:h-18 flex items-center justify-center rounded-full bg-gradient-to-br from-amber-600 to-amber-700 shadow-lg group-hover:shadow-amber-500/50 transition-all duration-300 group-hover:scale-110">
                  <span className="material-symbols-outlined text-white text-xl sm:text-2xl md:text-3xl">
                    {feature.icon}
                  </span>
                </div>
                {/* Feature text */}
                <p className="text-sm sm:text-base md:text-lg font-bold text-amber-400 whitespace-nowrap group-hover:text-amber-300 transition-colors duration-300">
                  {feature.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Enhanced side gradients for fade effect */}
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-gray-900 via-gray-900/90 to-transparent pointer-events-none"></div>
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-gray-900 via-gray-900/90 to-transparent pointer-events-none"></div>
      
      {/* Top and bottom accent lines */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-transparent"></div>
    </section>
  );
};

export default FeaturesBar;
